import Vue from 'vue';
import { database } from "@/plugins/firebase";
import store from "@/store";
import _ from "lodash";
export const BalancesCollection = 'balances';
export const BalanceModule = {
    namespaced: true,
    state: [],
    mutations: {
        store(state, balance) {
            const x = state.find(x => x.id === balance.id);
            if (x) {
                if (_.isEqual(x, balance)) {
                    return;
                }
                state.splice(state.indexOf(x), 1, balance);
                store.dispatch('balance/storeCache');
                return;
            }
            state.push(balance);
            store.dispatch('balance/storeCache');
        },
        update(state, balance) {
            state.find((oldBalance, index) => {
                if (oldBalance.id === balance.id) {
                    Vue.set(state, index, balance);
                }
            });
        },
        destroy(state, balance) {
            const index = state.findIndex(item => balance.id === item.id);
            if (index !== -1) {
                Vue.set(state[index].data, 'deletedAt', balance.data.deletedAt);
            }
        },
        clear(state) {
            state.splice(0, state.length);
        },
    },
    actions: {
        async listen(context) {
            context.commit('clear');
            //await context.dispatch('loadCache');
            return database.collection(BalancesCollection).onSnapshot(snapshot => {
                for (let change of snapshot.docChanges()) {
                    switch (change.type) {
                        case 'added':
                            context.commit('store', { id: change.doc.id, data: change.doc.data() });
                            break;
                        case 'modified':
                            context.commit('update', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                        case 'removed':
                            context.commit('destroy', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                    }
                }
            });
        },
        async storeCache(context) {
            localStorage.removeItem(BalancesCollection);
            try {
                localStorage.setItem(BalancesCollection, JSON.stringify(context.state));
            }
            catch (e) { }
        },
        async loadCache(context) {
            const cache = localStorage.getItem(BalancesCollection);
            if (!cache) {
                return;
            }
            const balances = JSON.parse(cache);
            for (const balance of balances) {
                context.commit('store', { id: balance.id, data: balance.data });
            }
        },
    },
    getters: {
        // Active entities only (for selection dropdowns) - deletedAt is null, undefined, or missing
        active(state) {
            return state.filter(b => !b.data.deletedAt);
        },
        // All entities including deleted (for historical views)
        all(state) {
            return state;
        },
        // Deleted entities only (for admin filter)
        deleted(state) {
            return state.filter(b => !!b.data.deletedAt);
        },
        // Active first, then deleted (for management list per FR-010)
        allSortedForManagement(state) {
            const active = state.filter(b => !b.data.deletedAt);
            const deleted = state.filter(b => !!b.data.deletedAt);
            return [...active, ...deleted];
        },
    }
};
